import React, { useState } from "react";
import styles from "./Tooltip.module.css";

interface IToolTipProps {
  children?: JSX.Element | string;
  tooltipText: string;
}

const Tooltip = ({ children, tooltipText }: IToolTipProps): JSX.Element => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleCloseTooltip = () => {
    setShowTooltip(false);
  };

  const handleOpenTooltip = () => {
    setShowTooltip(true);
  };

  return (
    <div
      className={styles.tooltip}
      tabIndex={0}
      onClick={() => setShowTooltip(!showTooltip)}
      onMouseEnter={handleOpenTooltip}
      onFocus={handleOpenTooltip}
      onBlur={handleCloseTooltip}
      onMouseLeave={handleCloseTooltip}
    >
      {children}
      {showTooltip && <span className={styles.tooltiptext}>{tooltipText}</span>}
    </div>
  );
};

export default Tooltip;
